<template>
  <el-tabs v-model="activeName" class="reward-tabs" style="width: 100%;">
    <!-- 奖品管理标签页 -->
    <el-tab-pane label="奖品管理" name="first">
      <div class="main">
        <div class="main_r">
          <div class="page-top">
            <div class="title_line">奖品列表</div>

            <div class="filter-strip">
              <div class="filter-strip__fields">
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">奖品名称</label>
                  <el-input v-model="rewardQuery.rewardName" placeholder="输入名称" clearable size="small"></el-input>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">状态</label>
                  <el-select v-model="rewardQuery.status" placeholder="全部" size="small">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="上架" value="1"></el-option>
                    <el-option label="下架" value="0"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="filter-strip__actions">
                <el-button type="primary" size="small" icon="el-icon-search" @click="clickRewardQuery">查询</el-button>
                <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickRewardQueryReset">重置</el-button>
                <span class="filter-strip__sep"></span>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="clickRewardAdd">新增</el-button>
              </div>
            </div>
          </div>

          <!-- 列表 -->
          <div class="table-section">
            <div class="table-container">
              <el-table :data="rewardList" class="reward-table" :header-cell-style="tableHeaderStyle" :cell-style="tableCellStyle" @sort-change="handleRewardSortChange">
                <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="rewardImageUrl" label="奖品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <el-image v-if="scope.row.rewardImageUrl" :src="getImageUrl(scope.row.rewardImageUrl)" :preview-src-list="[getImageUrl(scope.row.rewardImageUrl)]" style="width: 50px; height: 50px; border-radius: 4px;"></el-image>
                    <span v-else class="text-muted">-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="rewardName" label="奖品名称" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="requiredPoints" label="所需积分" width="100" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="stock" label="实际库存" width="100" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="totalStock" label="展示库存" width="100" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="exchangedCount" label="已兑换" width="100" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="status" label="状态" width="80" sortable="custom" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="small" effect="plain">
                      {{ scope.row.status === 1 ? '上架' : '下架' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="sortOrder" label="排序" width="80" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="210" sortable="custom" align="center" class-name="col-mono"></el-table-column>
                <el-table-column label="英文名称" min-width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="text-muted">{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['reward_name']) || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="德文名称" min-width="120" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="text-muted">{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['reward_name']) || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Operation" label="操作" width="150" fixed="right" align="center">
                  <template slot-scope="scope">
                    <div class="action-group">
                      <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickRewardEdit(scope.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                        <el-link :underline="false" type="danger" icon="el-icon-delete" @click="clickRewardDelete(scope.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="翻译" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-s-opportunity" @click="clickI18n(scope.row)"></el-link>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination-wrapper">
            <el-pagination
              @size-change="handleRewardSizeChange"
              @current-change="handleRewardCurrentChange"
              :current-page="rewardPageNo"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="rewardPageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="rewardTotal">
            </el-pagination>
          </div>
        </div>

        <!-- 新增奖品弹框 -->
        <el-dialog title="新增奖品" :visible.sync="dialogRewardAdd" width="720px" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="rewardAddForm" :model="rewardAddData" label-width="100px">
              <el-form-item label="奖品名称" :required="true">
                <el-input v-model="rewardAddData.rewardName" placeholder="请输入奖品名称" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item label="所需积分" :required="true">
                <el-input-number v-model="rewardAddData.requiredPoints" :min="1" placeholder="请输入所需积分" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="库存数量" :required="true">
                <el-input-number v-model="rewardAddData.stock" :min="0" placeholder="请输入库存数量" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="状态" :required="true">
                <el-select v-model="rewardAddData.status" placeholder="请选择状态" style="width: 100%">
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排序号">
                <el-input-number v-model="rewardAddData.sortOrder" :min="0" placeholder="请输入排序号" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="奖品图片">
                <el-upload
                  class="cover-uploader"
                  :action="''"
                  :http-request="handleRewardAddUpload"
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true">
                  <img v-if="rewardAddData.rewardImageUrl" :src="getImageUrl(rewardAddData.rewardImageUrl)" class="cover-image">
                  <i v-else class="el-icon-plus cover-uploader-icon"></i>
                </el-upload>
                <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
              </el-form-item>
              <el-form-item label="奖品描述">
                <el-input type="textarea" :rows="4" v-model="rewardAddData.description" placeholder="请输入奖品描述" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RewardAdd()">确 认</el-button>
            <el-button @click="dialogRewardAdd = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 新增奖品弹框 End -->

        <!-- 编辑奖品弹框 -->
        <el-dialog title="编辑奖品" :visible.sync="dialogRewardEdit" width="720px" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="rewardEditForm" :model="rewardEditData" label-width="100px">
              <el-form-item label="奖品名称" :required="true">
                <el-input v-model="rewardEditData.rewardName" placeholder="请输入奖品名称" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item label="所需积分" :required="true">
                <el-input-number v-model="rewardEditData.requiredPoints" :min="1" placeholder="请输入所需积分" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="库存数量" :required="true">
                <el-input-number v-model="rewardEditData.stock" :min="0" placeholder="请输入库存数量" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="状态" :required="true">
                <el-select v-model="rewardEditData.status" placeholder="请选择状态" style="width: 100%">
                  <el-option label="上架" :value="1"></el-option>
                  <el-option label="下架" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排序号">
                <el-input-number v-model="rewardEditData.sortOrder" :min="0" placeholder="请输入排序号" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="奖品图片">
                <el-upload
                  class="cover-uploader"
                  :action="''"
                  :http-request="handleRewardEditUpload"
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true">
                  <img v-if="rewardEditData.rewardImageUrl" :src="getImageUrl(rewardEditData.rewardImageUrl)" class="cover-image">
                  <i v-else class="el-icon-plus cover-uploader-icon"></i>
                </el-upload>
                <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
              </el-form-item>
              <el-form-item label="奖品描述">
                <el-input type="textarea" :rows="4" v-model="rewardEditData.description" placeholder="请输入奖品描述" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="RewardEdit()">确 认</el-button>
            <el-button @click="dialogRewardEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑奖品弹框 End -->

        <!-- 翻译管理 -->
        <i18n-translation-dialog
          :visible.sync="dialogI18n"
          :entity-type="i18nEntityType"
          :entity-id="i18nEntityId"
          :fields="i18nFields">
        </i18n-translation-dialog>
      </div>
    </el-tab-pane>

    <!-- 兑换记录标签页 -->
    <el-tab-pane label="兑换记录管理" name="second">
      <div class="main">
        <div class="main_r">
          <div class="page-top">
            <div class="title_line">兑换记录</div>

            <div class="filter-strip">
              <div class="filter-strip__fields">
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">用户ID</label>
                  <el-input v-model="exchangeQuery.userid" placeholder="输入用户ID" clearable size="small"></el-input>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">奖品名称</label>
                  <el-input v-model="exchangeQuery.rewardName" placeholder="输入奖品名称" clearable size="small"></el-input>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">状态</label>
                  <el-select v-model="exchangeQuery.status" placeholder="全部" size="small">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="处理中" value="0"></el-option>
                    <el-option label="已发货" value="1"></el-option>
                  </el-select>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">开始日期</label>
                  <el-date-picker v-model="exchangeQuery.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">结束日期</label>
                  <el-date-picker v-model="exchangeQuery.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" size="small"></el-date-picker>
                </div>
              </div>
              <div class="filter-strip__actions">
                <el-button type="primary" size="small" icon="el-icon-search" @click="clickExchangeQuery">查询</el-button>
                <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickExchangeQueryReset">重置</el-button>
              </div>
            </div>
          </div>

          <!-- 列表 -->
          <div class="table-section">
            <div class="table-container">
              <el-table :data="exchangeList" class="reward-table" :header-cell-style="tableHeaderStyle" :cell-style="tableCellStyle" @sort-change="handleExchangeSortChange">
                <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="userid" label="用户ID" width="120" sortable="custom" align="center" class-name="col-mono"></el-table-column>
                <el-table-column prop="rewardImageUrl" label="奖品图片" width="100" align="center">
                  <template slot-scope="scope">
                    <el-image v-if="scope.row.rewardImageUrl" :src="getImageUrl(scope.row.rewardImageUrl)" :preview-src-list="[getImageUrl(scope.row.rewardImageUrl)]" style="width: 50px; height: 50px; border-radius: 4px;"></el-image>
                    <span v-else class="text-muted">-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="rewardName" label="奖品名称" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="points" label="消耗积分" width="100" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="recipientName" label="收货人" width="100" sortable="custom" align="center"></el-table-column>
                <el-table-column prop="contactPhone" label="联系电话" width="120" sortable="custom" align="center" class-name="col-mono"></el-table-column>
                <el-table-column prop="shippingAddress" label="收货地址" min-width="180" sortable="custom" show-overflow-tooltip></el-table-column>
                <el-table-column prop="trackingNumber" label="快递单号" width="150" sortable="custom" align="center" class-name="col-mono">
                  <template slot-scope="scope">
                    <span>{{ scope.row.trackingNumber || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="150" sortable="custom" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="text-muted">{{ scope.row.remark || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="80" sortable="custom" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small" effect="plain">
                      {{ scope.row.status === 1 ? '已发货' : '处理中' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="createTime" label="兑换时间" width="160" sortable="custom" align="center" class-name="col-mono"></el-table-column>
                <el-table-column prop="Operation" label="操作" width="160" fixed="right" align="center">
                  <template slot-scope="scope">
                    <div class="action-group">
                      <el-tooltip v-if="scope.row.status === 0" class="item" effect="dark" content="发货" placement="top" :enterable="false">
                        <el-button type="primary" size="mini" @click="clickExchangeShip(scope.row)">发货</el-button>
                      </el-tooltip>
                      <el-tooltip v-if="scope.row.status === 1" class="item" effect="dark" content="取消发货" placement="top" :enterable="false">
                        <el-button type="danger" size="mini" @click="clickExchangeCancelShip(scope.row)">取消发货</el-button>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination-wrapper">
            <el-pagination
              @size-change="handleExchangeSizeChange"
              @current-change="handleExchangeCurrentChange"
              :current-page="exchangePageNo"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="exchangePageSize"
              layout="total, prev, pager, next, sizes, jumper"
              :total="exchangeTotal">
            </el-pagination>
          </div>
        </div>

        <!-- 发货弹框 -->
        <el-dialog title="发货处理" :visible.sync="dialogExchangeShip" width="520px" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="exchangeShipForm" :model="exchangeShipData" label-width="100px">
              <el-form-item label="快递单号" :required="true">
                <el-input v-model="exchangeShipData.trackingNumber" placeholder="请输入快递单号" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" :rows="4" v-model="exchangeShipData.remark" placeholder="请输入备注" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="ExchangeShip()">确 认</el-button>
            <el-button @click="dialogExchangeShip = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 发货弹框 End -->

        <!-- 取消发货确认弹框 -->
        <el-dialog title="取消发货确认" :visible.sync="dialogExchangeCancelShip" width="520px" class="newAdd" :close-on-click-modal="false">
          <div class="addUser_body">
            <el-form ref="exchangeCancelShipForm" :model="exchangeCancelShipData" label-width="100px">
              <el-form-item label="备注" :required="true">
                <el-input type="textarea" :rows="4" v-model="exchangeCancelShipData.remark" placeholder="请输入备注（如：快递退回）" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="ExchangeCancelShip()">确 认</el-button>
            <el-button @click="dialogExchangeCancelShip = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 取消发货确认弹框 End -->
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    I18nTranslationDialog
  },
  data () {
    return {
      activeName: 'first',
      // 奖品管理相关数据
      rewardQuery: {
        rewardName: '',
        status: ''
      },
      rewardList: [],
      rewardTotal: 0,
      rewardPageNo: 1,
      rewardPageSize: 10,
      rewardSortField: '',
      rewardSortOrder: '',
      dialogRewardAdd: false,
      rewardAddData: {
        rewardName: '',
        rewardImageUrl: '',
        requiredPoints: 1,
        stock: 0,
        status: 1,
        sortOrder: 0,
        description: ''
      },
      dialogRewardEdit: false,
      rewardEditData: {
        id: '',
        rewardName: '',
        rewardImageUrl: '',
        requiredPoints: 1,
        stock: 0,
        status: 1,
        sortOrder: 0,
        description: ''
      },
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'REWARD',
      i18nFields: [
        { name: 'reward_name', label: '奖品名称', type: 'input' },
        { name: 'description', label: '奖品描述', type: 'textarea' }
      ],
      translationMap: {},
      uploadAction: Vue.prototype.global.Url_Base + 'Upload/image',
      // 兑换记录相关数据
      exchangeQuery: {
        userid: '',
        rewardName: '',
        status: '',
        startDate: '',
        endDate: ''
      },
      exchangeList: [],
      exchangeTotal: 0,
      exchangePageNo: 1,
      exchangePageSize: 10,
      exchangeSortField: '',
      exchangeSortOrder: '',
      dialogExchangeShip: false,
      exchangeShipData: {
        id: '',
        trackingNumber: '',
        remark: ''
      },
      dialogExchangeCancelShip: false,
      exchangeCancelShipData: {
        id: '',
        remark: ''
      }
    }
  },
  mounted () {
    this.RewardList()
  },
  methods: {
    // ========== 奖品管理方法 ==========
    handleRewardSizeChange (val) {
      this.rewardPageSize = val
      this.RewardList()
    },
    handleRewardCurrentChange (val) {
      this.rewardPageNo = val
      this.RewardList()
    },
    handleRewardSortChange ({ prop, order }) {
      this.rewardSortField = prop || ''
      this.rewardSortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.rewardPageNo = 1
      this.RewardList()
    },
    clickRewardQuery () {
      this.rewardPageNo = 1
      this.RewardList()
    },
    clickRewardQueryReset () {
      this.rewardQuery.rewardName = ''
      this.rewardQuery.status = ''
      this.clickRewardQuery()
    },
    clickRewardAdd () {
      this.dialogRewardAdd = true
      this.rewardAddData.rewardName = ''
      this.rewardAddData.rewardImageUrl = ''
      this.rewardAddData.requiredPoints = 1
      this.rewardAddData.stock = 0
      this.rewardAddData.status = 1
      this.rewardAddData.sortOrder = 0
      this.rewardAddData.description = ''
    },
    clickRewardEdit (row) {
      this.dialogRewardEdit = true
      this.rewardEditData.id = row.id
      this.rewardEditData.rewardName = row.rewardName
      this.rewardEditData.rewardImageUrl = row.rewardImageUrl || ''
      this.rewardEditData.requiredPoints = row.requiredPoints
      this.rewardEditData.stock = row.stock
      this.rewardEditData.status = row.status
      this.rewardEditData.sortOrder = row.sortOrder
      this.rewardEditData.description = row.description || ''
    },
    clickRewardDelete (row) {
      var that = this
      this.$deleteConfirm('确定删除该奖品？').then(function () {
        that.RewardDelete(row.id)
      })
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      this.dialogI18n = true
    },
    RewardList: function () {
      var that = this
      var params = {
        tempUuid: localStorage.getItem('tempUuid'),
        page: that.rewardPageNo,
        pageSize: that.rewardPageSize,
        rewardName: that.rewardQuery.rewardName,
        status: that.rewardQuery.status,
        sortField: that.rewardSortField,
        sortOrder: that.rewardSortOrder
      }
      axios.get(Vue.prototype.global.Url_RewardList, { 
        params: params,
        headers: {
          'Accept-Language': 'zh'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            that.rewardList = response.data.data.list
            that.rewardTotal = response.data.data.total
            that.loadTranslations('REWARD', that.rewardList, 'id')
          } else {
            Vue.prototype.$message.error(response.data.message || '查询失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('查询失败')
        })
    },
    RewardAdd: function () {
      var that = this
      if (!that.rewardAddData.rewardName) {
        Vue.prototype.$message.error('请输入奖品名称')
        return
      }
      if (!that.rewardAddData.requiredPoints || that.rewardAddData.requiredPoints <= 0) {
        Vue.prototype.$message.error('所需积分必须大于0')
        return
      }
      if (that.rewardAddData.stock < 0) {
        Vue.prototype.$message.error('库存数量不能小于0')
        return
      }
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        rewardName: that.rewardAddData.rewardName,
        rewardImageUrl: that.rewardAddData.rewardImageUrl,
        requiredPoints: that.rewardAddData.requiredPoints,
        stock: that.rewardAddData.stock,
        status: that.rewardAddData.status,
        sortOrder: that.rewardAddData.sortOrder,
        description: that.rewardAddData.description
      }
      axios.post(Vue.prototype.global.Url_RewardAdd, data, {
        headers: {
          'Accept-Language': 'zh',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '新增成功')
            that.RewardList()
            that.dialogRewardAdd = false
          } else {
            Vue.prototype.$message.error(response.data.message || '新增失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('新增失败')
          that.dialogRewardAdd = false
        })
    },
    RewardEdit: function () {
      var that = this
      if (!that.rewardEditData.rewardName) {
        Vue.prototype.$message.error('请输入奖品名称')
        return
      }
      if (!that.rewardEditData.requiredPoints || that.rewardEditData.requiredPoints <= 0) {
        Vue.prototype.$message.error('所需积分必须大于0')
        return
      }
      if (that.rewardEditData.stock < 0) {
        Vue.prototype.$message.error('库存数量不能小于0')
        return
      }
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        id: that.rewardEditData.id,
        rewardName: that.rewardEditData.rewardName,
        rewardImageUrl: that.rewardEditData.rewardImageUrl,
        requiredPoints: that.rewardEditData.requiredPoints,
        stock: that.rewardEditData.stock,
        status: that.rewardEditData.status,
        sortOrder: that.rewardEditData.sortOrder,
        description: that.rewardEditData.description
      }
      axios.post(Vue.prototype.global.Url_RewardEdit, data, {
        headers: {
          'Accept-Language': 'zh',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '编辑成功')
            that.RewardList()
            that.dialogRewardEdit = false
          } else {
            Vue.prototype.$message.error(response.data.message || '编辑失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('编辑失败')
          that.dialogRewardEdit = false
        })
    },
    RewardDelete: function (id) {
      var that = this
      axios.post(Vue.prototype.global.Url_RewardDelete + '?tempUuid=' + localStorage.getItem('tempUuid') + '&id=' + id, null, {
        headers: {
          'Accept-Language': 'zh'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '删除成功')
            that.RewardList()
          } else {
            Vue.prototype.$message.error(response.data.message || '删除失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('删除失败')
        })
    },
    beforeImageUpload (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        Vue.prototype.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        Vue.prototype.$message.error('上传图片大小不能超过 2MB!')
        return false
      }

      return true
    },
    handleRewardAddUpload (options) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      data.sign = Vue.prototype.FunGetSign(data)
      data.type = 'ajax'
      
      formData.append('file', options.file)
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      
      // 显示 loading
      const loading = Vue.prototype.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          var resData = response.data.data || {}
          var imageUrl = ''
          if (typeof resData === 'string') {
            imageUrl = resData
          } else if (resData.absoluteUrl) {
            imageUrl = resData.absoluteUrl
          } else if (resData.relativeUrl) {
            imageUrl = Vue.prototype.global.Url_Base + resData.relativeUrl
          }
          that.rewardAddData.rewardImageUrl = imageUrl
          Vue.prototype.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          Vue.prototype.$message.error('上传失败：' + response.data.msg)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        Vue.prototype.$message.error('上传失败！')
        options.onError(error)
      }).finally(function () {
        // 关闭 loading
        loading.close()
      })
    },
    handleRewardEditUpload (options) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      data.sign = Vue.prototype.FunGetSign(data)
      data.type = 'ajax'
      
      formData.append('file', options.file)
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      
      // 显示 loading
      const loading = Vue.prototype.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          var resData = response.data.data || {}
          var imageUrl = ''
          if (typeof resData === 'string') {
            imageUrl = resData
          } else if (resData.absoluteUrl) {
            imageUrl = resData.absoluteUrl
          } else if (resData.relativeUrl) {
            imageUrl = Vue.prototype.global.Url_Base + resData.relativeUrl
          }
          that.rewardEditData.rewardImageUrl = imageUrl
          Vue.prototype.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          Vue.prototype.$message.error('上传失败：' + response.data.msg)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        Vue.prototype.$message.error('上传失败！')
        options.onError(error)
      }).finally(function () {
        // 关闭 loading
        loading.close()
      })
    },
    // ========== 兑换记录管理方法 ==========
    handleExchangeSizeChange (val) {
      this.exchangePageSize = val
      this.ExchangeList()
    },
    handleExchangeCurrentChange (val) {
      this.exchangePageNo = val
      this.ExchangeList()
    },
    handleExchangeSortChange ({ prop, order }) {
      this.exchangeSortField = prop || ''
      this.exchangeSortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.exchangePageNo = 1
      this.ExchangeList()
    },
    clickExchangeQuery () {
      this.exchangePageNo = 1
      this.ExchangeList()
    },
    clickExchangeQueryReset () {
      this.exchangeQuery.userid = ''
      this.exchangeQuery.rewardName = ''
      this.exchangeQuery.status = ''
      this.exchangeQuery.startDate = ''
      this.exchangeQuery.endDate = ''
      this.clickExchangeQuery()
    },
    clickExchangeShip (row) {
      this.dialogExchangeShip = true
      this.exchangeShipData.id = row.id
      this.exchangeShipData.trackingNumber = ''
      this.exchangeShipData.remark = ''
    },
    clickExchangeCancelShip (row) {
      this.dialogExchangeCancelShip = true
      this.exchangeCancelShipData.id = row.id
      this.exchangeCancelShipData.remark = ''
    },
    ExchangeList: function () {
      var that = this
      var params = {
        tempUuid: localStorage.getItem('tempUuid'),
        page: that.exchangePageNo,
        pageSize: that.exchangePageSize,
        sortField: that.exchangeSortField,
        sortOrder: that.exchangeSortOrder
      }
      if (that.exchangeQuery.userid) params.userid = that.exchangeQuery.userid
      if (that.exchangeQuery.rewardName) params.rewardName = that.exchangeQuery.rewardName
      if (that.exchangeQuery.status !== '') params.status = that.exchangeQuery.status
      if (that.exchangeQuery.startDate) params.startDate = that.exchangeQuery.startDate
      if (that.exchangeQuery.endDate) params.endDate = that.exchangeQuery.endDate
      
      axios.get(Vue.prototype.global.Url_ExchangeList, { 
        params: params,
        headers: {
          'Accept-Language': 'zh'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            that.exchangeList = response.data.data.list
            that.exchangeTotal = response.data.data.total
          } else {
            Vue.prototype.$message.error(response.data.message || '查询失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('查询失败')
        })
    },
    ExchangeShip: function () {
      var that = this
      if (!that.exchangeShipData.trackingNumber) {
        Vue.prototype.$message.error('请输入快递单号')
        return
      }
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        id: that.exchangeShipData.id,
        trackingNumber: that.exchangeShipData.trackingNumber,
        remark: that.exchangeShipData.remark
      }
      axios.post(Vue.prototype.global.Url_ExchangeShip, data, {
        headers: {
          'Accept-Language': 'zh',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '发货成功')
            that.ExchangeList()
            that.dialogExchangeShip = false
          } else {
            Vue.prototype.$message.error(response.data.message || '发货失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('发货失败')
          that.dialogExchangeShip = false
        })
    },
    ExchangeCancelShip: function () {
      var that = this
      if (!that.exchangeCancelShipData.remark) {
        Vue.prototype.$message.error('请输入备注')
        return
      }
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        id: that.exchangeCancelShipData.id,
        remark: that.exchangeCancelShipData.remark
      }
      axios.post(Vue.prototype.global.Url_ExchangeCancelShip, data, {
        headers: {
          'Accept-Language': 'zh',
          'Content-Type': 'application/json'
        }
      })
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success(response.data.data || '取消发货成功')
            that.ExchangeList()
            that.dialogExchangeCancelShip = false
          } else {
            Vue.prototype.$message.error(response.data.message || '取消发货失败')
          }
        })
        .catch(function (error) {
          console.log(error)
          Vue.prototype.$message.error('取消发货失败')
          that.dialogExchangeCancelShip = false
        })
    },
    // ========== 通用方法 ==========
    getImageUrl (url) {
      if (!url) return ''
      if (typeof url === 'object') {
        if (url.absoluteUrl) {
          return url.absoluteUrl
        }
        if (url.relativeUrl) {
          return Vue.prototype.global.Url_Base + url.relativeUrl
        }
        return ''
      }
      const urlStr = String(url)
      if (urlStr.indexOf('http://') === 0 || urlStr.indexOf('https://') === 0) {
        return urlStr
      }
      return Vue.prototype.global.Url_Base + urlStr
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
    },
    tableCellStyle ({ column }) {
      if (column.type === 'index' || column.property === 'Operation' || column.property === 'status' || column.property === 'isOnline') {
        return { textAlign: 'center' }
      }
      return { textAlign: 'left' }
    }
  },
  watch: {
    activeName (newVal) {
      if (newVal === 'first') {
        this.RewardList()
      } else if (newVal === 'second') {
        this.ExchangeList()
      }
    },
    dialogI18n (val) {
      if (!val) {
        this.loadTranslations('REWARD', this.rewardList, 'id')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  RewardManagement — 运动主题设计规范 v1.0
 *  主色: #1565C0 (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.main {
  /* 变量已移至 .reward-tabs，确保祖先元素可用 */
}

.main_r {
  padding: 16px 20px 14px;
  box-sizing: border-box;
}

.page-top {
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field--compact {
  gap: 4px;

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 表格区域 */
.table-section {
  margin-top: 12px;
}

.table-container {
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 奖品表格 */
.reward-table {
  /deep/ .col-mono {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

.text-muted {
  color: var(--aptus-text-muted);
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }
  }

  .el-button {
    margin-left: 0;
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .main_r {
    padding: 10px;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__body {
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px 24px;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}

/deep/ .el-button--danger {
  font-weight: 500;
  border-radius: 6px;
}

.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed var(--aptus-border);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: var(--aptus-primary);
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: var(--aptus-text-muted);
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: var(--aptus-text-muted);
  margin-top: 8px;
}

.confirmMsg {
  text-align: center;
  font-size: 16px;
  color: var(--aptus-text);
  padding: 20px 0;
}

/* tabs 样式 */
.reward-tabs {
  --aptus-primary: #1565C0;
  --aptus-primary-light: #1E7AE6;
  --aptus-primary-bg: #E8F1FA;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-warning-bg: #FFF8E1;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F0F2F5;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;

  /deep/ .el-tabs__header {
    margin-bottom: 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border);
    padding: 0 20px;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: var(--aptus-border);
  }

  /deep/ .el-tabs__item {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    font-weight: 500;
    color: var(--aptus-text-secondary);

    &.is-active {
      color: var(--aptus-primary);
      font-weight: 600;
    }

    &:hover {
      color: var(--aptus-primary-light);
    }
  }

  /deep/ .el-tabs__active-bar {
    background-color: var(--aptus-primary);
    height: 2px;
  }

  /deep/ .el-tabs__content {
    padding: 0;
  }
}
</style>
